/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The different types of counters in the Orders microservice
 */
export enum EnumOrdersCounterTypes {
    /**
     * Counter type for Orders
     */
    Order = 0,
    /**
     * Counter type for Orders in cash
     */
    CashOrder = 1,
    /**
     * A counter for weighing slips
     */
    WeighingSlip = 2,
    /**
     * A counter for requisitions
     */
    Requisition = 3,
}
